import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { SEO } from "../../components/SEO/SEO";
import { SEO_CONFIG } from "../../components/SEO/seoConfig";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const relatedPages = [
    {
      title: "Home",
      description: "Return to our homepage",
      path: "/",
      icon: "🏠",
    },
    
    {
      title: "Moving Calculator",
      description: "Estimate your moving costs",
      path: "/calculator",
      icon: "🧮",
    },
    
    {
      title: "FAQ",
      description: "Find answers to common questions",
      path: "/faq",
      icon: "❓",
    },
    {
      title: "Contact Support",
      description: "Get help from our team",
      path: "/support/ticket",
      icon: "💬",
    },
  ];

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <SEO {...SEO_CONFIG.notFound} />
      <div className="max-w-4xl w-full text-center">
        {/* 404 Hero */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-3xl font-semibold text-gray-800 mb-2">
            Page Not Found
          </h2>
          <p className="text-lg text-gray-600">
            Oops! The page you're looking for seems to have moved or doesn't
            exist.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg transition-colors"
          >
            ← Go Back
          </button>
          <Link
            to="/"
            className="px-6 py-3 bg-primary hover:bg-primary-dark text-white rounded-lg transition-colors"
          >
            Go to Homepage
          </Link>
        </div>

        {/* Related Pages */}
        <section>
          <h3 className="text-2xl font-semibold text-gray-800 mb-6">
            Find What You Need
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {relatedPages.map((page) => (
              <Link
                key={page.path}
                to={page.path}
                className="p-6 bg-white border border-gray-200 rounded-lg hover:shadow-lg hover:border-primary transition-all duration-300 text-left group"
              >
                <div className="text-4xl mb-3">{page.icon}</div>
                <h4 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-primary transition-colors">
                  {page.title}
                </h4>
                <p className="text-sm text-gray-600">{page.description}</p>
              </Link>
            ))}
          </div>
        </section>

        {/* Help Text */}
        <div className="mt-12 p-6 bg-blue-50 rounded-lg">
          <p className="text-gray-700">
            <strong>Need help?</strong> If you think this is an error, please{" "}
            <Link to="/support/ticket" className="text-primary hover:underline">
              contact our support team
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
